import { render, staticRenderFns } from "./IconHealthConnect.vue?vue&type=template&id=13abcf4f&scoped=true"
import script from "./IconHealthConnect.vue?vue&type=script&lang=js"
export * from "./IconHealthConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13abcf4f",
  null
  
)

export default component.exports